<template>
    <fb-form-body>

        <el-form :model="formData" :rules="rules" ref="form" label-width="130px">


            <el-form-item label="服务端名称" prop="name" :error="formErrorMsg.name" class="fb-form-item">
                <el-input v-model="formData.name" placeholder="服务端名称"></el-input>
            </el-form-item>

            <el-form-item label="服务端标识" prop="flag" :error="formErrorMsg.flag" class="fb-form-item">
                <el-input v-model="formData.flag" placeholder="服务端标识"></el-input>
            </el-form-item>


            <el-form-item label="配置参数" prop="mfg" :error="formErrorMsg.mfg" class="fb-form-item" style="max-width: 800px">

                <el-table
                        :data="options"
                        border
                        style="width: 100%">
                    <el-table-column
                            prop="key"
                            label="参数名称"
                            >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.key" placeholder="参数名称"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="value"
                            label="参数值"
                           >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.value" placeholder="参数值"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="desc"
                            label="参数描述">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.desc" placeholder="参数描述"></el-input>
                        </template>
                    </el-table-column>
                </el-table>


                <div>
                    <el-button size="mini"  @click="handleAddParam">新增参数</el-button>
                </div>

            </el-form-item>



            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    export default {
        name: "SpdeviceAdd",
        components: {},
        data() {
            return {

                api: {
                    add: this.$api.spDevServer.add
                },
                formErrorMsg: {
                    name: '',
                    flag: ''
                },
                options:[],
                formData: {
                    name: '',
                    flag: '',
                    options:''
                },
                rules: {

                    name: [
                        {required: true, message: '服务端名称不能为空', trigger: 'blur'},
                    ],
                    flag: [
                        {required: true, message: '服务端标识不能为空', trigger: 'blur'},
                    ]
                }
            }
        },
        watch:{
            options:{
                deep:true,
                handler(){
                    this.formData.options = JSON.stringify(this.options);
                }
            }
        },
        methods: {

            handleAddParam(){
                this.options.push({key:'',value:'',desc:''});
            },
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {

                        vm.$http.post(vm.api.add, vm.$qs.stringify(this.formData)).then((resp) => {

                            if (resp.data.status === 200) {
                                vm.$message({
                                    type: 'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            } else if (resp.data.status === 400) {

                                console.log(vm.$refs[form]);


                                if (resp.data.data.errorFields) {
                                    resp.data.data.errorFields.forEach(function (a) {

                                        vm.formErrorMsg[a.name] = '';
                                        vm.$nextTick(() => {
                                            vm.formErrorMsg[a.name] = a.message;
                                        });
                                    });
                                }

                                if (resp.data.desc) {
                                    vm.$message({
                                        type: "error",
                                        message: resp.data.desc
                                    });
                                }


                            } else {
                                vm.$message({
                                    type: "error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },
        created() {
            if (this.$route.query.parent) {
                this.formData.parent = this.$route.query.parent
            }
        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }


</style>


<style>
    .editor-item > .el-form-item__content {
        line-height: initial !important;
    }
</style>